import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

const Footer = () => {
  const { primaryColor } = useTheme();
  const currentYear = new Date().getFullYear();

  return (
    <footer
      style={{
        background: '#fff',
        borderTop: '1px solid #eee',
        padding: '12px 24px',
        margin: '0',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '10px',
        fontSize: '13px',
        color: '#666'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <span>&copy; {currentYear}</span>
        <span className="powered-by-branding" style={{ color: primaryColor, fontWeight: '600' }}>WebDekho</span>
        <span>- All Rights Reserved</span>
      </div>

      <div className="powered-by-branding" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <span>Made with</span>
        <i className="bi bi-heart-fill" style={{ color: '#dc3545', fontSize: '12px' }}></i>
        <span>by</span>
        <a
          href="https://webdekho.in"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
            transition: 'opacity 0.2s'
          }}
          onMouseEnter={(e) => e.currentTarget.style.opacity = '0.8'}
          onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
        >
          <img
            src="/material/Webdekho_Logo.png"
            alt="WebDekho"
            style={{ height: '50px', width: 'auto', objectFit: 'contain' }}
          />
        </a>
      </div>
    </footer>
  );
};

export default Footer;
